import { render, staticRenderFns } from "./backend-medal.vue?vue&type=template&id=809acbb4&"
import script from "./backend-medal.vue?vue&type=script&lang=js&"
export * from "./backend-medal.vue?vue&type=script&lang=js&"
import style0 from "./backend-medal.vue?vue&type=style&index=0&id=809acbb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports